module.exports = __webpack_public_path__ + "img/academy-course-illustration2.651b6498.png";